// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__KB2zb","input":"Checkbox_input__3thCx","checkbox":"Checkbox_checkbox__gcGRm","text":"Checkbox_text__21oOY"};